import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 按托盘出库保存
export function saveToByPallet(data) {
  return request({
    url: URL.warehouseIn.saveToByPallet,
    method: 'post',
    data
  })
}

// 按托盘出库保存
export function saveToByBox(data) {
  return request({
    url: URL.warehouseIn.saveToByBox,
    method: 'post',
    data
  })
}

// 查询出库批次日志
export function queryOutWarehouseBatchLog(data) {
  return request({
    url: URL.warehouseIn.queryOutWarehouseBatchLog,
    method: 'get',
    params: data
  })
}

// 库龄调整
export function storageAgeAdjustment(data) {
  return request({
    url: URL.warehouseIn.storageAgeAdjustment,
    method: 'post',
    data
  })
}

// 撤销出库
export function rollbackOutWarehouse(data) {
  return request({
    url: URL.warehouseIn.rollbackOutWarehouse,
    method: 'post',
    data
  })
}

// 修改出库备注
export function updateIssueRemarks(data) {
  return request({
    url: URL.warehouseIn.updateIssueRemarks,
    method: 'post',
    data
  })
}

// 批量出库
export function batchExWarehouse(data) {
  return request({
    url: URL.warehouseIn.batchExWarehouse,
    method: 'post',
    data
  })
}
